// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"462b9e1a","769":"8299e08d"}[chunkId] + ".chunk.css";
};